<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <div v-if="!withOutstream">
      <el-divider>
        <span class="pink">Image</span>
      </el-divider>
      <el-form-item
        label="Image"
        prop="image_url"
        :rules="urlRule('image_url')"
      >
        <file-input
          accept="image/jpeg, image/png, image/gif"
          v-model="item.image_url"
        ></file-input>
      </el-form-item>
      <el-form-item
        label="Content text"
        prop="content"
        :rules="stringRule('content')"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10 }"
          placeholder="please input content"
          v-model="item.content"
        >
        </el-input>
      </el-form-item>
    </div>
    <div v-else-if="withOutstream">
      <video-item replay isOutstream ref="video">
        <el-form
          ref="ruleFormInner"
          :model="item"
          label-position="left"
          label-width="160px"
        >
          <el-form-item
            label="Content text"
            prop="content"
            :rules="stringRule('content')"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="please input content"
              v-model="item.content"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </video-item>
    </div>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      item: {
        advertiser_icon: "",
        advertiser_name: "",
        content: "",
        image_url: "",
      },
    };
  },
  computed: {
    withOutstream() {
      return _.includes(this.value._type, "WithOutstream");
    },
    getAdvertiserInfoById() {
      return this.$store.getters["advertiser/getAdvertiserById"](
        this.value.advertiser
      );
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  watch: {},
  methods: {
    async getData(setObj) {
      setObj.content = this.item.content.replaceAll("\n", "\\n");
      setObj.advertiser_icon = this.getAdvertiserInfoById.icon;
      setObj.advertiser_name = this.getAdvertiserInfoById.name;
      if (!this.withOutstream) {
        setObj.image_url = this.item.image_url;
      } else if (this.withOutstream) {
        setObj = await this.$refs.video.getData(setObj, "100%", 200);
      }
      return setObj;
    },
    setData(row) {
      this.item.content = row.content.replaceAll("\\n", "\n");
      this.item.advertiser_icon = row.advertiser_icon;
      this.item.advertiser_name = row.advertiser_name;
      if (!this.withOutstream) {
        this.item.image_url = row.image_url;
      } else if (this.withOutstream) {
        this.$refs.video.setData(row);
      }
    },
  },
};
</script>

<style></style>
